import {env} from './env';

// Arc tables

export const AGENTS = `AGENTS${env}`;
export const BUCKETS = `BUCKETS${env}`;
export const BUYERS = `BUYERS${env}`;
export const FIRMS = `FIRMS${env}`;
export const HSC_TRACKING = `HSC_TRACKING${env}`;
export const LENDERS = `LENDERS${env}`;
export const PROPERTIES = `PROPERTIES${env}`;
export const PROPERTY_HISTORY = `PROPERTY_HISTORY${env}`;
export const SELLERS = `SELLERS${env}`;
export const SELLER_COUNT = `SELLER_COUNT${env}`
export const SUMMIT_ESCROW_TRACKING = `SUMMIT_ESCROW_TRACKING${env}`;
export const TENANTS = `TENANTS${env}`;
export const UNDERWRITING_EXPENSES_CAMS = `UNDERWRITING_EXPENSES_CAMS${env}`;
export const UNDERWRITING_MULTI_TENANT = `UNDERWRITING_MULTI_TENANT${env}`;
export const UNDERWRITING_PARCELS = `UNDERWRITING_PARCELS${env}`;
export const UNDERWRITING_RENT_SCHEDULE = `UNDERWRITING_RENT_SCHEDULE${env}`;
export const UNDERWRITING_SINGLE_TENANT = `UNDERWRITING_SINGLE_TENANT${env}`;
export const UNDERWRITING_TENANTS = `UNDERWRITING_TENANTS${env}`;
export const UNDERWRITING_TENANT_TYPES = `UNDERWRITING_TENANT_TYPES${env}`;
//export const TEAM = 'TEAM';
export const TEAM = `TEAM${env}`;
export const ASSIGNED_TERRITORIES = `ASSIGNED_TERRITORIES${env}`
export const TRAINING = `TRAINING${env}`;
export const TRAINING_CONTENT = `TRAINING_CONTENT${env}`;
export const HSC_LOAN_QUOTES = `HSC_LOAN_QUOTES${env}`;
export const PROPERTY_PAYMENT_TEAM = `PROPERTY_PAYMENT_TEAM${env}`
export const PROPERTY_LOAN_NOTES = `PROPERTY_LOAN_NOTES${env}`;
export const PROPERTY_NOTES = `PROPERTY_NOTES${env}`;
export const VENDOR_NOTES = `VENDOR_NOTES${env}`;
export const TERRITORIES_STNL = `TERRITORIES_STNL${env}`;
export const TERRITORIES_MTNL = `TERRITORIES_MTNL${env}`;
export const TERRITORIES = `TERRITORIES${env}`;
export const TEAM_MEMBER = `TEAM_MEMBER${env}`;
export const PROPOSAL =  `PROPOSAL${env}`;
export const HSC_FOLLOW_UP_AGENTS = `HSC_FOLLOW_UP_AGENTS${env}`;
export const HSC_HOTLIST_SELLERS = `HSC_HOTLIST_SELLERS${env}`;
export const HOT_LIST =  `HOT_LIST${env}`;
export const HOT_LIST_TRACKER =  `HOT_LIST_TRACKER${env}`;
export const NEW_DEVELOPMENT =  `NEW_DEVELOPMENT${env}`;
export const NEW_DEVELOPMENT_HISTORY =  `NEW_DEVELOPMENT_HISTORY${env}`;
export const NEED_OWNER =  `NEED_OWNER${env}`;
export const STORE_LOI_DATA = `LOI_DATA${env}`;
export const REFERRING_OUTSIDE_AGENT = `REFERRING_OUTSIDE_AGENT${env}`;
export const BUYERS_COUNT = `BUYERS_COUNT${env}`;
export const AGENTS_COUNT = `AGENTS_COUNT${env}`;
export const FIRMS_COUNT = `FIRMS_COUNT${env}`
export const VENDORS = `VENDORS${env}`;
export const OFFICES = `OFFICES${env}`;
export const INVESTORS = `INVESTORS${env}`;
export const INVESTOR_HOT_LIST = `INVESTOR_HOT_LIST${env}`;
export const PROPERTY_CONTRACT_INFO = `PROPERTY_CONTRACT_INFO${env}`;
export const PROPERTY_OWNERSHIP = `PROPERTY_OWNERSHIP${env}`;
export const PROPERTY_OWNERSHIP_INVESTORS = `PROPERTY_OWNERSHIP_INVESTORS${env}`;
export const PROPERTY_ACCOUNT_NUMBERS = `PROPERTY_ACCOUNT_NUMBERS${env}`
export const FEATURED_ACTIVATED_LOG = `FEATURED_ACTIVATED_LOG${env}`
export const MARKETS = `MARKETS${env}`
export const TERRITORIES_V2 = `TERRITORIES_V2${env}`
export const TEAM_LICENSES = `TEAM_LICENSES${env}`
export const TERRITORY_CITIES_V2 = `TERRITORY_CITIES_V2${env}`
export const TEAM_MEMBER_CRM_CREDENTIALS = `TEAM_MEMBER_CRM_CREDENTIALS${env}`;

// Arc email tables

export const EXPIRING_LISTINGS = `EXPIRING_LISTINGS${env}`;
export const INDUSTRIAL_BUYER = `INDUSTRIAL_BUYER${env}`;
export const IN_NEGOTIATION_PROPERTY_SERVICE = `IN_NEGOTIATION_PROPERTY_SERVICE${env}`;
export const NEW_ACTIVE_PROPERTIES = `NEW_ACTIVE_PROPERTIES${env}`;
export const NEW_CLOSED_PROPERTIES = `NEW_CLOSED_PROPERTIES${env}`;
export const OFFICE_BUYER = `OFFICE_BUYER${env}`;
export const RETAIL_MT_BUYER = `RETAIL_MT_BUYER${env}`;
export const RETAIL_STNL_BUYER = `RETAIL_STNL_BUYER${env}`;
export const TODAYS_EXPIRING_LISTINGS = `TODAYS_EXPIRING_LISTINGS${env}`;
export const UNDER_CONTRACT_PROPERTY_SERVICE = `UNDER_CONTRACT_PROPERTY_SERVICE${env}`;

export const PRICING_ANALYSIS = `PRICING_ANALYSIS${env}`


// consts
export const OVERFLOW_TABLE_WIDTH = 125;
